import { render, staticRenderFns } from "./OrderFoodItemManagement.vue?vue&type=template&id=351db6ca&scoped=true"
import script from "./OrderFoodItemManagement.vue?vue&type=script&lang=js"
export * from "./OrderFoodItemManagement.vue?vue&type=script&lang=js"
import style0 from "./OrderFoodItemManagement.vue?vue&type=style&index=0&id=351db6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351db6ca",
  null
  
)

export default component.exports